webpackJsonp([245603546996802],{

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IntegrationsPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _semanticUiReact = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IntegrationPage = function IntegrationPage(_ref) {
	  var node = _ref.node;
	
	  return _react2.default.createElement(
	    _semanticUiReact.List.Item,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/integration/' + node.slug + '/', style: { fontSize: '18pt', margin: '10px' } },
	      node.name
	    )
	  );
	};
	var IntegrationsPage = function IntegrationsPage(_ref2) {
	  var data = _ref2.data;
	  return _react2.default.createElement(
	    'div',
	    { style: { maxWidth: 1260, margin: '0 auto' } },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Find growth tools by integration | Find Growth Tools'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'A curated list of the best SaaS growth tools that integrate with your favourite apps.' })
	    ),
	    _react2.default.createElement(
	      _semanticUiReact.Segment,
	      { basic: true },
	      _react2.default.createElement(
	        _semanticUiReact.Breadcrumb,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Breadcrumb.Section,
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/', style: { color: '#dcddde' } },
	            _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle left' }),
	            'Home'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      {
	        style: {
	          fontSize: '1.5rem',
	          color: '#fff'
	        }
	      },
	      'Find by',
	      _react2.default.createElement(
	        'span',
	        { style: { fontSize: '3.25rem' } },
	        ' Integration'
	      )
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      { style: { fontSize: '1.25em', color: '#fff' } },
	      'Click on products from the list to find growth tools you can integrate.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 960, margin: '0 auto' } },
	      _react2.default.createElement(
	        _semanticUiReact.Segment,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.List,
	          null,
	          data.allContentfulIntegration.edges.map(function (edge) {
	            return _react2.default.createElement(IntegrationPage, { node: edge.node });
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	  );
	};
	
	exports.default = IntegrationsPage;
	var IntegrationsPageQuery = exports.IntegrationsPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-integrations-js-301681836281358d4a99.js